<script lang="ts">
  import PubSub from 'pubsub-js'
  import { createEventDispatcher } from 'svelte'
  import ImagePreviewModal from '@/components/appDriver/ImagePreviewModal.svelte'
  import { currentPage, enquiryResult } from '@/components/appDriver/store'
  import PageTopupHistory from '@/components/appDriver/topup/PageTopupHistory.svelte'

  export let showHistoryButton: boolean = false

  const dispatch = createEventDispatcher<{ driverNameTap: void }>()

  $: roundedRating = Math.round($enquiryResult?.user?.averageRating ?? 0)

  let previewImageUrl: string | null = null
  let previewImageAlt = ''

  function openImagePreview(imageUrl = '', imageAlt = '') {
    if ($currentPage !== 'home' || !imageUrl) {
      return
    }

    previewImageUrl = imageUrl
    previewImageAlt = imageAlt
  }

  function closeImagePreview() {
    previewImageUrl = null
    previewImageAlt = ''
  }
</script>

{#if $enquiryResult}
  <div class="rounded-2xl bg-white p-4 shadow-[0_8px_24px_rgba(30,64,175,0.08)] space-y-4">

    {#if $currentPage !== 'home'}

      <div class="flex items-center justify-between space-x-4">
        <div>
          <div>Hello</div>
          <div class="text-xl font-bold">{$enquiryResult.user.name}</div>
        </div>
        <img src="{$enquiryResult.user.profileImage}" width="80" height="80" class="mx-auto h-20 w-20 rounded-lg object-cover">
      </div>

    {:else}

      <div class="space-y-3">
        <div class="flex items-start gap-3">
          <div class="shrink-0">
            <button
              type="button"
              class="block"
              on:click={() => openImagePreview($enquiryResult.user.profileImage, 'Driver profile')}
            >
              <img
                src="{$enquiryResult.user.profileImage}"
                width="64"
                height="64"
                class="h-16 w-16 rounded-full object-cover cursor-zoom-in"
                alt="Driver profile"
              >
            </button>
          </div>
          <div class="min-w-0 flex-1 pt-0.5 text-sm">
            <button
              type="button"
              class="block max-w-full truncate text-left font-semibold text-slate-900"
              on:click={() => dispatch('driverNameTap')}
            >
              {$enquiryResult.user.name}
            </button>
            <div class="mt-1 flex items-center gap-1 text-xs">
              <span class="tracking-tight text-amber-400">★★★★★</span>
              <span class="font-medium text-slate-700">{roundedRating.toFixed(1)} ດາວ</span>
            </div>
            <div class="mt-1 text-xs text-slate-600">ຊົ່ວໂມງບິນ: {$enquiryResult.user.lifeTimeHours.toLocaleString()} ຊມ</div>
          </div>
        </div>

        <div class="flex items-center gap-3 rounded-xl bg-slate-50 px-3 py-2.5">
          <button
            type="button"
            class="shrink-0"
            on:click={() => openImagePreview($enquiryResult.user.vehicleImage, 'Vehicle image')}
          >
            <img
              src="{$enquiryResult.user.vehicleImage}"
              class="h-16 w-24 rounded-lg object-cover cursor-zoom-in"
              alt="Driver vehicle"
            >
          </button>
          <div class="min-w-0 flex-1 text-sm leading-5 text-slate-800">
            <div>ຍີ່ຫໍ້ລົດ: {$enquiryResult.user.vehicleBrand}</div>
            <div>ລຸ້ນລົດ: {$enquiryResult.user.vehicleModel}</div>
            <div>ປ້າຍລົດ: {$enquiryResult.user.vehiclePlateNo}</div>
          </div>
        </div>
      </div>

      <slot name="home-actions" />

    {/if}

    {#if showHistoryButton}
      <div class="bg-blue-primary rounded-lg p-2 text-white text-center font-semibold" on:click={() => PubSub.publish('DRIVER.CHANGE_PAGE', { component: PageTopupHistory })}>ປະຫວັດການຊຳລະ</div>
    {/if}

  </div>
{/if}

<ImagePreviewModal
  isOpen={Boolean(previewImageUrl)}
  imageUrl={previewImageUrl ?? ''}
  imageAlt={previewImageAlt}
  onClose={closeImagePreview}
/>
